"use strict";

define('service/locale.service',['require','exports','module','appkit/service','moment','config','bootstrap-datepicker'],function (require, exports, module) {
  var Service = require('appkit/service');
  var moment = require('moment');
  var config = require('config');
  require('bootstrap-datepicker');
  var LocaleService = Service.extend({
    replies: {
      'get:moment:locale': 'getMomentLocale',
      'get:moment:longdateformat': 'getMomentLongDateFormat',
      'get:placeholder:locale': 'getDatePlaceholderForCurrentLocale'
    },
    LONG_DATE_FORMAT_TOKENS: ['LT', 'LTS', 'L', 'LL', 'LLL', 'LLLL'],
    isValidLongFormatToken: function isValidLongFormatToken(token) {
      return token && this.LONG_DATE_FORMAT_TOKENS.indexOf(token) !== -1;
    },
    getMomentLocale: function getMomentLocale() {
      return moment.locale();
    },
    getMomentLongDateFormat: function getMomentLongDateFormat(formatToken) {
      var localeLongDateFormat;
      if (!this.isValidLongFormatToken(formatToken)) {
        return;
      }
      localeLongDateFormat = moment.localeData().longDateFormat(formatToken);
      return localeLongDateFormat ? localeLongDateFormat : moment.localeData('en').longDateFormat(formatToken);
    },
    getDatePlaceholderForCurrentLocale: function getDatePlaceholderForCurrentLocale() {
      return this.getMomentLongDateFormat('L');
    }
  });
  module.exports = LocaleService;
});

